
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SecureComponent } from './secure.component';
import { NavComponent } from './nav/nav.component';
import { MenuComponent } from './menu/menu.component';
import { UsersComponent } from './users/users.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RouteConfigLoadEnd, RouterModule } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';

import { RolesComponent } from './roles/roles.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { UserCreateComponent } from './users/user-create/user-create.component';
import { UserEditComponent } from './users/user-edit/user-edit.component';
import { RoleCreateComponent } from './roles/role-create/role-create.component';
import { RoleEditComponent } from './roles/role-edit/role-edit.component';
import { PlantsComponent } from './plants/plants.component';
import { PlantEditComponent } from './plants/plant-edit/plant-edit.component';
import { PlantSaveComponent } from './plants/plant-save/plant-save.component';
import { DictionaryComponent } from './dictionary/dictionary.component';
import { SearchComponent } from './components/search/search.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { BootstrapContentModalComponent } from './bootstrap-content-modal/bootstrap-content-modal.component';
import { CentroCostoComponent } from './centro-costo/centro-costo.component';
import { CentroCostoSaveComponent } from './centro-costo/centro-costo-save/centro-costo-save.component';
import { FuenteContratoComponent } from './fuente-contrato/fuente-contrato.component';
import { FuenteContratoSaveComponent } from './fuente-contrato/fuente-contrato-save/fuente-contrato-save.component';
import { PersonalComponent } from './personal/personal.component';
import { PersonalSaveComponent } from './personal/personal-save/personal-save.component';
import { BrowserModule } from "@angular/platform-browser";
//import { ScannerComponent } from './scanner/scanner.component';
//import { BarcodeScannerLivestreamModule } from "ngx-barcode-scanner";
import { CaptureComponent } from './capture/capture.component';
import { NgQrScannerModule } from 'angular2-qrscanner';
import { CodigoQrComponent } from './codigo-qr/codigo-qr.component';
//import {NgxBarcodeScannerModule} from '@eisberg-labs/ngx-barcode-scanner';
import { BarcodeComponent } from './barcode/barcode.component';
//import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { AppInfoDialogComponent } from './barcode/app-info-dialog/app-info-dialog.component';
import { FormatsDialogComponent } from './barcode/formats-dialog/formats-dialog.component';
import { AppInfoComponent } from './barcode/app-info/app-info.component';

import { AppUiModule } from './app-ui.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ControlLineaModalComponent } from './capture/control-linea-modal/control-linea-modal.component';







//import {FlashMessagesModule} from 'angular2-flash-messages';
//import {FlashMessagesService} from 'angular2-flash-messages';
//import { NgFlashMessagesModule } from 'ng-flash-messages';

@NgModule({
  declarations: [
    SecureComponent,
    NavComponent,
    MenuComponent,
    UsersComponent,
    DashboardComponent,
    ProfileComponent,
    RolesComponent,
    PaginatorComponent,
    UserCreateComponent,
    UserEditComponent,
    RoleCreateComponent,
    RoleEditComponent,
    PlantsComponent,
    PlantEditComponent,
    DictionaryComponent,
    SearchComponent,
    SpinnerComponent,
    BootstrapContentModalComponent,
    PlantSaveComponent,
    CentroCostoComponent,
    CentroCostoSaveComponent,
    FuenteContratoComponent,
    FuenteContratoSaveComponent,
    PersonalComponent,
    PersonalSaveComponent,
    //ScannerComponent,
    CaptureComponent,
    CodigoQrComponent,
    BarcodeComponent,
    AppInfoDialogComponent,
    FormatsDialogComponent,
    AppInfoComponent,
    ControlLineaModalComponent,

  ],
  exports: [
    SecureComponent,
  //  ScannerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    //BarcodeScannerLivestreamModule,
  //  NgxBarcodeScannerModule,
    NgQrScannerModule,
   // ZXingScannerModule,
    AppUiModule,
    BrowserAnimationsModule

    //FlashMessagesModule
    //NgFlashMessagesModule.forRoot()
  ],
  providers: []
})
export class SecureModule { }
